import { useEffect, useMemo, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { firestore as db } from "../../../../../backend/firebaseconfig";
import Banner from "../../Components/Banners/Banner";
import SecondaryButton from "../../Components/Buttons/SecondaryButton";
import { useUserEmail } from "../../../../../context/UserEmailContext";
import { ReactComponent as Check2Logo } from "../../../../../assets/icons/aml/check2_logo.svg";
const clean = (v) => (v ?? "").toString().trim();

export default function Announcement() {
  const { userEmail } = useUserEmail();

  const [announcement, setAnnouncement] = useState("");
  const [enabled, setEnabled] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [type, setType] = useState("warning");

  const seenKey = useMemo(() => {
    const keyUser = clean(userEmail).toLowerCase();
    return keyUser ? `aml_announcement_seen_${keyUser}` : "";
  }, [userEmail]);

  useEffect(() => {
    if (!userEmail) return; // wait until we know who the user is

    const ref = doc(db, "Compliance", "Check²");

    const unsub = onSnapshot(
      ref,
      (snap) => {
        const data = snap.exists() ? snap.data() : {};
        const msg = clean(data?.announcement);
        const isEnabled = !!data?.enabled;
        const t = clean(data?.announcementType || "warning").toLowerCase();

        setAnnouncement(msg);
        setEnabled(isEnabled);
        setType(t || "warning");



        // Popup only once per session (per user)
        if (isEnabled && msg && seenKey) {
          const hasSeen = sessionStorage.getItem(seenKey) === "1";
          if (!hasSeen) {
            setShowPopup(true);
            sessionStorage.setItem(seenKey, "1");
          }
        }

        // If admin disables announcement live, close popup
        if (!isEnabled || !msg) {
          setShowPopup(false);
        }
      },
      () => {
        // optional: handle permission errors etc.
      }
    );

    return () => unsub();
  }, [userEmail, seenKey]);

  if (!enabled || !announcement) return null;

  return (
    <>
      <Banner type={type} message={announcement} />

      {showPopup && (
        <div className="submission-popup-overlay">
          <div className="submission-popup-container check2-logo">
            <Check2Logo />
            <div className="AML-Text-Title">Service Announcement</div>
              <Banner type={type} message={announcement} />
            {/* <div className="announcement-popup-body">
            </div> */}
            <SecondaryButton
              label="Got it"
              onClick={() => setShowPopup(false)}
            />
          </div>
        </div>
      )}
    </>
  );
}
